const toSafeString = (value) => String(value ?? '').trim();

export const normalizeCatalogOptions = (list, { useCodeInLabel = true } = {}) => {
  return (Array.isArray(list) ? list : [])
    .map((item) => {
      if (!item || typeof item !== 'object') {
        const normalized = toSafeString(item);
        if (normalized === '') {
          return null;
        }

        return {
          value: normalized,
          label: normalized,
          meta: {},
        };
      }

      const meta = item.meta || item;
      const code = toSafeString(meta.code ?? item.code);
      const name = toSafeString(meta.name ?? item.name);
      const value = toSafeString(item.value ?? meta.id ?? item.id ?? code ?? name);

      if (value === '') {
        return null;
      }

      let label = toSafeString(item.label);
      if (label === '') {
        label = useCodeInLabel && code && name
          ? `${code} - ${name}`
          : (name || code || value);
      }

      return {
        value,
        label,
        meta,
      };
    })
    .filter(Boolean);
};

export const normalizeGeoOptions = (list) => {
  return normalizeCatalogOptions(list, { useCodeInLabel: true });
};

export const normalizeCurrencyOptions = (list, { useCodeInLabel = false, uppercase = true } = {}) => {
  return normalizeCatalogOptions(list, { useCodeInLabel })
    .map((option) => {
      const rawCode = toSafeString(option?.meta?.code ?? option?.code ?? option?.value);
      const code = uppercase ? rawCode.toUpperCase() : rawCode;

      if (code === '') {
        return null;
      }

      const label = toSafeString(option?.label || option?.meta?.name || code);

      return {
        value: code,
        label: label || code,
        meta: option?.meta || {},
      };
    })
    .filter(Boolean);
};
